import { DESKTOP } from 'chemistry'

const applyContainerSx = (props, data = {}) => {
  props.sx = {
    ...props.sx
  }
  const { maxWidth } = data
  if (maxWidth) {
    props.sx = {
      ...props.sx,
      [DESKTOP]: {
        maxWidth: `${maxWidth}px`
      }
    }
  }
  return {
    ...props
  }
}

export { applyContainerSx }
